module.exports = __webpack_public_path__ + "static/media/IS.d66dc95a.png";